module.exports = __webpack_public_path__ + "static/img/icon1.5d184f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad-server/icon1.png
// module id = q2iY
// module chunks = 1